import {
  SmButton,
  SmInputText,
  SmSelector,
} from '@smiles/smiles-react-design-system';
import React, { useMemo, useState } from 'react';

import { useUser } from '@/hooks/useUser';
import useApi from '@/hooks/useApi';
import useEvent from '@/hooks/useEvent';

import { Alert } from '@/components/Alert';

import { submitOptin } from '@/services/requests/Optin';
import { TOptinContent } from '@/services/requests/Liferay/types';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';

import { getValue } from '@/helpers/GetValueHelper';

import { TScreens } from '..';

type TProps = {
  data: TOptinContent;
  onClose: () => void;
  onRedirect: (value: TScreens) => void;
};

export function ScreenForm({ data, onClose, onRedirect }: TProps) {
  const user = useUser();
  const { ApiOptin, ApiInteractions } = useApi();

  const event = useEvent();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [terms, setTerms] = useState(false);
  const [input, setInput] = useState(getValue(user, 'memberNumber', ''));

  const isButtonEnabled = useMemo(() => {
    return terms === true && input !== '';
  }, [terms, input]);

  const handleSubmit = async () => {
    dispatchInteraction(ApiInteractions, 'extra_optin_click_confirm', {
      recommendationId: event.data.recommendationId,
    });
    if (terms && input) {
      setIsSubmitting(true);
      const result = (await submitOptin(ApiOptin, {
        promotionId: data.promo_id,
        cpfOrMemberNumber: input,
      })) as TScreens;

      onRedirect(result);
    }
  };

  const handleClose = (_closeFunction: () => void) => {
    dispatchInteraction(ApiInteractions, 'extra_optin_click_close', {
      recommendationId: event.data.recommendationId,
    });

    _closeFunction();
  };

  const handleTerms = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatchInteraction(ApiInteractions, 'extra_optin_rules_accepted', {
      recommendationId: event.data.recommendationId,
    });
    setTerms(e.target.checked);
  };

  return (
    <div className="smls-optin__modal-content">
      <div className="smls-optin__button--close">
        <SmButton
          onClick={() => handleClose(onClose)}
          isPill
          isOutlined
          icon={<span className="material-icons">close</span>}
        />
      </div>
      <h4 className="smls-optin__title">{data.title}</h4>
      <p
        className="smls-optin__description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: data.description }}
      />
      {!user.isLogged && (
        <SmInputText
          label=" "
          className="smls-optin__input"
          placeholder="Insira o CPF ou Número Smiles"
          value={input}
          onChange={e => setInput(e.target.value)}
        />
      )}
      <div className="smls-optin__checkbox">
        <SmSelector
          label=" "
          type="checkbox"
          checked={terms}
          onChange={e => handleTerms(e)}
        />
        <span>
          {`${data.terms.terms_prefix_label} `}
          <button
            type="button"
            className="smls-optin__terms"
            onClick={e => {
              e.preventDefault();
              onRedirect('terms');
              return false;
            }}
          >
            {data.terms.terms_suffix_label}
          </button>
        </span>
      </div>
      <SmButton
        className="smls-optin__button--send"
        onClick={handleSubmit}
        isPill
        isOutlined
        isLoading={isSubmitting}
        disabled={!isButtonEnabled}
        text={data.button_label}
      />
      <Alert />
    </div>
  );
}
